import { HttpClient } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export const APP_FEATURE_FLAGS_HTTP_CLIENT = new InjectionToken<HttpClient>('App Feature Flags Http Client');
